import { render, staticRenderFns } from "./dsaStats.vue?vue&type=template&id=cf2cf47e&scoped=true&"
import script from "./dsaStats.vue?vue&type=script&lang=js&"
export * from "./dsaStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2cf47e",
  null
  
)

export default component.exports